export const TranslatedTextPasswordRecovery = {
    PASSWORD_RECOV_TITTLE:"mcfLoginShell.passwordRecovery.tittle",
    PASSWORD_NEW_TITTLE:"mcfLoginShell.passwordRecovery.newPasswordTitle",
    PASSWORD_RECOV_SUB_TITTLE:"mcfLoginShell.passwordRecovery.subTittle",
    PASSWORD_RECOV_EMAIL_INPUT:"mcfLoginShell.passwordRecovery.emailInput",
    PASSWORD_RECOV_EMAIL_INPUT_REQUIRED:"mcfLoginShell.passwordRecovery.emailInputRequired",
    PASSWORD_RECOV_EMAIL_INPUT_INVALID:"mcfLoginShell.passwordRecovery.emailInputInvalid",
    PASSWORD_RECOV_RECOVERY_SUBTITTLE:"mcfLoginShell.passwordRecovery.recoverySubtittle",
    PASSWORD_RECOV_PASSWORD_INPUT:"mcfLoginShell.passwordRecovery.passwordInput",
    PASSWORD_RECOV_CONFIRM_PASSWORD_INPUT:"mcfLoginShell.passwordRecovery.confirmPasswordInput",
    PASSWORD_RECOV_PASSWORD_REQUIRED:"mcfLoginShell.passwordRecovery.passwordRequired",
    PASSWORD_RECOV_CONFIRM_PASSWORD_REQUIRED:"mcfLoginShell.passwordRecovery.confirmPasswordRequired",
    PASSWORD_RECOV_PASSWORDINVALID:"mcfLoginShell.passwordRecovery.passwordInvalid",
    PASSWORD_RECOV_CONFIRM_PASSWORD_EQUALS:"mcfLoginShell.passwordRecovery.confirmPasswordEquals",
    PASSWORD_RECOV_SUCCESS_MESSAGE_EMAIL:"mcfLoginShell.passwordRecovery.successMessageEmail",
    PASSWORD_RECOV_SUCCESS_MESSAGE_RESET:"mcfLoginShell.passwordRecovery.successMessageReset",
    PASSWORD_RECOV_ERROR_MESSAGE_RESET:"mcfLoginShell.passwordRecovery.errorResetPassword",
    SEND: "mcfLoginShell.send",
    GO_BACK: "mcfLoginShell.goBack",
    TERMS_AND_CONDITIONS: "mcfLoginShell.users.termsAndConditions",
    ERROR_MESSAGES:"mcfLoginShell.errorMessages.errorMessage500"
}
